export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      gallery: "Gallery",
      about: "About",
      contact: "Get Quote"
    },
    
    // Hero Section
    hero: {
      location: "Serving Edmonton & Area",
      title: "Expert Concrete Cutting & Basement Window Expansion",
      subtitle: "Want to turn your dark basement into a bright, legal living space? Don't risk your foundation with amateurs.",
      description: "At South Palmyra Inc, we provide professional concrete cutting and full-service window installations with zero stress for you.",
      whyTrust: "Why homeowners trust us:",
      feature1: "Fully Protected: WCB coverage and Commercial General Liability insurance",
      feature2: "Code Compliant: Every egress window meets Alberta Building Code",
      feature3: "Clean & Precise: Specialized diamond cutting equipment for minimal dust",
      feature4: "Local & Reliable: Proudly serving Edmonton with competitive pricing",
      ctaPrimary: "Get Free Estimate",
      alsoAvailable: "Also available:",
      whyTrustCommercial: "Why Commercial Clients Choose Us:",
      commercialFeature1: "Large-Scale Commercial Concrete Cutting & Demolition",
      commercialFeature2: "Licensed, Insured & WCB Covered for Peace of Mind",
      commercialFeature3: "On-Schedule Delivery for Multi-Unit & Commercial Projects",
      commercialFeature4: "Flexible Scheduling to Minimize Business Disruption"
    },

    // Commercial
    commercial: {
      badge: "ANY SIZE • ANY COMPLEXITY",
      capabilitiesTitle: "Commercial Capabilities",
      mainTitle: "ANY SIZE • ANY COMPLEXITY",
      subtitle: "Trusted by contractors, property managers, and developers across Alberta",
      projectTypesTitle: "Commercial Project Types",
      servicesHeader: "Commercial Services",
      servicesSubtitle: "Professional concrete solutions for contractors, property managers, and developers",
      anySize: {
        title: "Any Size Project",
        description: "From single cuts to entire building demolitions - we handle projects of any scale"
      },
      anyComplexity: {
        title: "Any Complexity",
        description: "Specialized equipment and expertise for the most challenging concrete cutting projects"
      },
      multiUnit: {
        title: "Multi-Unit & High-Rise",
        description: "Experience with large commercial buildings, condos, and multi-story structures"
      },
      minimalDisruption: {
        title: "Minimal Disruption",
        description: "Flexible scheduling and dust control to keep your business operations running smoothly"
      },
      projectHighRise: "Commercial High-Rise",
      projectDemolition: "Industrial Demolition",
      projectMultiUnit: "Multi-Unit Development",
      projectRenovation: "Commercial Renovation",
      scaleLarge: "Large Scale",
      scaleComplex: "Complex",
      scaleMultiStory: "Multi-Story",
      scalePrecision: "Precision Work"
    },
    
    // Services
    services: {
      title: "Our Services",
      subtitle: "Professional concrete solutions tailored to your project needs",
      cta: "Request a Quote",
      learnMore: "Learn More",
      service1: {
        title: "Window & Door Expansions",
        description: "Enlarging existing openings or cutting new ones in your foundation for natural light and safety.",
        feature1: "Foundation window openings - creating new egress windows for legal living spaces",
        feature2: "Existing opening expansion - enlarging basement windows to meet Alberta Building Code",
        feature3: "Door opening creation - new entry points for basement access",
        feature4: "Code compliant installations - ensuring all openings meet safety requirements",
        feature5: "Specialized diamond cutting equipment for minimal dust and perfect edges"
      },
      service2: {
        title: "Full Window Installation",
        description: "Turn-key solutions including excavation, window well setup, drainage systems, and energy-efficient window fitting.",
        feature1: "Complete excavation services - professional digging around foundation",
        feature2: "Window well installation - durable protective enclosures for basement windows",
        feature3: "Drainage system setup - preventing water buildup and basement flooding",
        feature4: "Energy-efficient window fitting - proper sealing and insulation",
        feature5: "Waterproofing and finishing - moisture protection for long-lasting results",
        feature6: "Full turn-key service - from start to finish with zero stress"
      },
      service3: {
        title: "Floor & Slab Cutting + Demolition",
        description: "Creating openings for new staircases and plumbing, plus full concrete demolition with debris haul-away.",
        feature1: "Floor cutting for staircases - precise openings for new basement access",
        feature2: "Plumbing openings - cutting concrete for new plumbing installations",
        feature3: "Wall and partition removal - demolishing unwanted concrete structures",
        feature4: "Old staircase removal - dismantling and disposal of concrete stairs",
        feature5: "Full debris haul-away - complete cleanup and waste removal",
        feature6: "Clean and precise work - minimal disruption to your property"
      }
    },
    
    // About
    about: {
      title: "About South Palmyra Inc.",
      subtitle: "Your trusted partner for professional concrete solutions in Edmonton, Alberta",
      heading: "Building Excellence in Concrete Services",
      paragraph1: "South Palmyra Inc. is a leading concrete cutting and construction service provider based in Edmonton, Alberta. We specialize in delivering high-quality, professional solutions for both residential and commercial projects.",
      paragraph2: "Our team of experienced professionals uses state-of-the-art equipment and proven techniques to ensure precision, safety, and efficiency in every project we undertake. From concrete cutting and basement window installations to demolition and waste removal, we handle it all with expertise and care.",
      paragraph3: "We pride ourselves on our commitment to customer satisfaction, attention to detail, and ability to complete projects on time and within budget. When you choose South Palmyra Inc., you're choosing a partner dedicated to excellence.",
      coreValues: "Our Core Values",
      value1: {
        title: "Excellence",
        description: "We maintain the highest standards of quality in every project we undertake"
      },
      value2: {
        title: "Precision",
        description: "Attention to detail and accuracy in all our concrete cutting and construction work"
      },
      value3: {
        title: "Customer First",
        description: "Your satisfaction is our priority, from consultation to project completion"
      },
      value4: {
        title: "Professional Service",
        description: "Experienced team equipped with state-of-the-art tools and techniques"
      }
    },
    
    // Why Choose Us
    whyChoose: {
      title: "Why Choose South Palmyra Inc.?",
      description: "We are Edmonton's trusted concrete cutting and construction specialists, delivering exceptional results for residential and commercial projects throughout Alberta.",
      feature1: {
        title: "Expert Team",
        description: "Experienced professionals with years of expertise in concrete work"
      },
      feature2: {
        title: "On-Time Service",
        description: "We respect your time and complete projects within agreed timelines"
      },
      feature3: {
        title: "Quality Guaranteed",
        description: "High-quality workmanship with attention to detail on every project"
      },
      feature4: {
        title: "Customer Focused",
        description: "Dedicated to exceeding expectations and ensuring satisfaction"
      },
      learnMore: "Learn More About Us"
    },
    
    // Testimonials
    testimonials: {
      title: "What Our Clients Say",
      subtitle: "Don't just take our word for it - hear from satisfied customers across Edmonton"
    },
    
    // Gallery
    gallery: {
      title: "Our Work",
      subtitle: "Explore our portfolio of completed projects across Edmonton and Alberta"
    },
    
    // Contact
    contact: {
      title: "Get a Free Quote",
      subtitle: "Tell us about your project and we'll get back to you within 24 hours",
      contactInfo: "Contact Information",
      phonePrimary: "Phone (Primary)",
      phoneSecondary: "Phone (Secondary)",
      email: "Email",
      serviceArea: "Service Area",
      emergency: "Emergency services available. Call us for urgent concrete cutting and demolition needs.",
      formTitle: "Request a Quote",
      formName: "Full Name",
      formPhone: "Phone Number",
      formEmail: "Email Address",
      formService: "Service Needed",
      formAddress: "Project Address",
      formDetails: "Project Details",
      formPhotos: "Project Photos (Optional)",
      formPhotosDesc: "Upload up to 5 photos to help us understand your project better",
      formUpload: "Click to upload photos",
      formUploadHint: "JPG, PNG up to 10MB each",
      formSubmit: "Submit Quote Request",
      formSubmitting: "Submitting...",
      formSuccess: "We'll review your request and get back to you within 24 hours",
      selectService: "Select a service"
    },
    
    // Footer
    footer: {
      description: "Professional concrete cutting, basement window installation, and demolition services in Edmonton, Alberta.",
      quickLinks: "Quick Links",
      ourServices: "Our Services",
      contactUs: "Contact Us",
      service1: "Window & Door Expansions",
      service2: "Full Window Installation",
      service3: "Floor & Slab Cutting",
      service4: "Concrete Demolition",
      service5: "Debris Haul-Away",
      allRights: "All rights reserved."
    }
  },
  
  uk: {
    // Navigation
    nav: {
      home: "Головна",
      services: "Послуги",
      gallery: "Галерея",
      about: "Про нас",
      contact: "Отримати пропозицію"
    },
    
    // Hero Section
    hero: {
      location: "Обслуговуємо Едмонтон та околиці",
      title: "Експертне різання бетону та розширення вікон підвалу",
      whyTrustCommercial: "Чому комерційні клієнти обирають нас:",
      commercialFeature1: "Великомасштабне комерційне різання та знесення бетону",
      commercialFeature2: "Ліцензовані, застраховані та покриті WCB для спокою",
      commercialFeature3: "Доставка за графіком для багатоквартирних та комерційних проектів",
      commercialFeature4: "Гнучкий графік для мінімізації перешкод бізнесу"
    },

    // Commercial
    commercial: {
      badge: "БУДЬ-ЯКИЙ РОЗМІР • БУДЬ-ЯКА СКЛАДНІСТЬ",
      capabilitiesTitle: "Комерційні Можливості",
      mainTitle: "БУДЬ-ЯКИЙ РОЗМІР • БУДЬ-ЯКА СКЛАДНІСТЬ",
      subtitle: "Довіряють підрядники, керуючі нерухомістю та забудовники по всій Альберті",
      projectTypesTitle: "Типи Комерційних Проектів",
      servicesHeader: "Комерційні Послуги",
      servicesSubtitle: "Професійні бетонні рішення для підрядників, керуючих нерухомістю та забудовників",
      anySize: {
        title: "Проект Будь-Якого Розміру",
        description: "Від окремих різів до повного знесення будівель - ми справляємося з проектами будь-якого масштабу"
      },
      anyComplexity: {
        title: "Будь-Яка Складність",
        description: "Спеціалізоване обладнання та досвід для найскладніших проектів різання бетону"
      },
      multiUnit: {
        title: "Багатоквартирні та Висотні",
        description: "Досвід роботи з великими комерційними будівлями, кондомініумами та багатоповерховими спорудами"
      },
      minimalDisruption: {
        title: "Мінімальні Перешкоди",
        description: "Гнучкий графік та контроль пилу для безперебійної роботи вашого бізнесу"
      },
      projectHighRise: "Комерційна Висотка",
      projectDemolition: "Промислове Знесення",
      projectMultiUnit: "Багатоквартирна Забудова",
      projectRenovation: "Комерційний Ремонт",
      scaleLarge: "Великий Масштаб",
      scaleComplex: "Складний",
      scaleMultiStory: "Багатоповерховий",
      scalePrecision: "Точна Робота"
    },
    
    // Services
    services: {
      title: "Наші послуги",
      subtitle: "Професійні бетонні рішення, адаптовані до потреб вашого проекту",
      cta: "Запитати пропозицію",
      learnMore: "Дізнатися більше",
      service1: {
        title: "Розширення вікон та дверей",
        description: "Розширення існуючих отворів або створення нових у вашому фундаменті для природного освітлення та безпеки.",
        feature1: "Віконні отвори у фундаменті - створення нових евакуаційних вікон для легальних житлових приміщень",
        feature2: "Розширення існуючих отворів - збільшення вікон підвалу відповідно до будівельного кодексу Альберти",
        feature3: "Створення дверних отворів - нові точки входу для доступу до підвалу",
        feature4: "Установки, що відповідають нормам - забезпечення відповідності всіх отворів вимогам безпеки",
        feature5: "Спеціалізоване алмазне обладнання для мінімального пилу та ідеальних країв"
      },
      service2: {
        title: "Повне встановлення вікон",
        description: "Комплексні рішення, включаючи земляні роботи, встановлення віконних колодязів, дренажні системи та енергоефективне встановлення вікон.",
        feature1: "Повні послуги з земляних робіт - професійне копання навколо фундаменту",
        feature2: "Встановлення віконного колодязя - міцні захисні корпуси для вікон підвалу",
        feature3: "Налаштування дренажної системи - запобігання скупченню води та затопленню підвалу",
        feature4: "Енергоефективна установка вікон - належна герметизація та ізоляція",
        feature5: "Гідроізоляція та оздоблення - захист від вологи для довготривалих результатів",
        feature6: "Повний сервіс під ключ - від початку до кінця без стресу"
      },
      service3: {
        title: "Різання підлог та плит + Знесення",
        description: "Створення отворів для нових сходів та сантехніки, а також повне знесення бетону з вивезенням сміття.",
        feature1: "Різання підлоги для сходів - точні отвори для нового доступу до підвалу",
        feature2: "Отвори для сантехніки - різання бетону для нових сантехнічних установок",
        feature3: "Видалення стін та перегородок - знесення небажаних бетонних конструкцій",
        feature4: "Видалення старих сходів - демонтаж та утилізація бетонних сходів",
        feature5: "Повне вивезення сміття - повне прибирання та видалення відходів",
        feature6: "Чиста та точна робота - мінімальні порушення вашої власності"
      }
    },
    
    // About
    about: {
      title: "Про South Palmyra Inc.",
      subtitle: "Ваш надійний партнер для професійних бетонних рішень в Едмонтоні, Альберта",
      heading: "Будуємо досконалість у бетонних послугах",
      paragraph1: "South Palmyra Inc. є провідним постачальником послуг з різання бетону та будівництва в Едмонтоні, Альберта. Ми спеціалізуємось на наданні високоякісних професійних рішень як для житлових, так і для комерційних проектів.",
      paragraph2: "Наша команда досвідчених професіоналів використовує найсучасніше обладнання та перевірені методи для забезпечення точності, безпеки та ефективності в кожному проекті. Від різання бетону та встановлення вікон у підвалі до знесення та вивезення відходів - ми робимо все з професіоналізмом.",
      paragraph3: "Ми пишаємося нашою відданістю задоволенню клієнтів, увагою до деталей та здатністю завершувати проекти вчасно та в межах бюджету. Обираючи South Palmyra Inc., ви обираєте партнера, відданого досконалості.",
      coreValues: "Наші основні цінності",
      value1: {
        title: "Досконалість",
        description: "Ми підтримуємо найвищі стандарти якості в кожному проекті"
      },
      value2: {
        title: "Точність",
        description: "Увага до деталей та точність у всіх наших роботах з різання бетону"
      },
      value3: {
        title: "Клієнт на першому місці",
        description: "Ваше задоволення - наш пріоритет, від консультації до завершення проекту"
      },
      value4: {
        title: "Професійний сервіс",
        description: "Досвідчена команда з сучасним обладнанням та технологіями"
      }
    },
    
    // Why Choose Us
    whyChoose: {
      title: "Чому обирають South Palmyra Inc.?",
      description: "Ми є надійними спеціалістами з різання бетону та будівництва в Едмонтоні, які забезпечують виняткові результати для житлових та комерційних проектів по всій Альберті.",
      feature1: {
        title: "Експертна команда",
        description: "Досвідчені професіонали з багаторічним досвідом роботи з бетоном"
      },
      feature2: {
        title: "Своєчасний сервіс",
        description: "Ми поважаємо ваш час і завершуємо проекти в узгоджені терміни"
      },
      feature3: {
        title: "Гарантована якість",
        description: "Високоякісна робота з увагою до деталей у кожному проекті"
      },
      feature4: {
        title: "Орієнтація на клієнта",
        description: "Відданість перевищенню очікувань та забезпеченню задоволення"
      },
      learnMore: "Дізнатися більше про нас"
    },
    
    // Testimonials
    testimonials: {
      title: "Що кажуть наші клієнти",
      subtitle: "Не вірте нам на слово - послухайте задоволених клієнтів по всьому Едмонтону"
    },
    
    // Gallery
    gallery: {
      title: "Наші роботи",
      subtitle: "Ознайомтеся з нашим портфоліо завершених проектів по Едмонтону та Альберті"
    },
    
    // Contact
    contact: {
      title: "Отримайте безкоштовну пропозицію",
      subtitle: "Розкажіть нам про свій проект, і ми зв'яжемося з вами протягом 24 годин",
      contactInfo: "Контактна інформація",
      phonePrimary: "Телефон (основний)",
      phoneSecondary: "Телефон (додатковий)",
      email: "Електронна пошта",
      serviceArea: "Зона обслуговування",
      emergency: "Доступні екстрені послуги. Зателефонуйте нам для термінового різання бетону та знесення.",
      formTitle: "Запит пропозиції",
      formName: "Повне ім'я",
      formPhone: "Номер телефону",
      formEmail: "Адреса електронної пошти",
      formService: "Необхідна послуга",
      formAddress: "Адреса проекту",
      formDetails: "Деталі проекту",
      formPhotos: "Фотографії проекту (необов'язково)",
      formPhotosDesc: "Завантажте до 5 фотографій, щоб допомогти нам краще зрозуміти ваш проект",
      formUpload: "Натисніть, щоб завантажити фотографії",
      formUploadHint: "JPG, PNG до 10 МБ кожен",
      formSubmit: "Надіслати запит",
      formSubmitting: "Надсилання...",
      formSuccess: "Ми розглянемо ваш запит і зв'яжемося з вами протягом 24 годин",
      selectService: "Виберіть послугу"
    },
    
    // Footer
    footer: {
      description: "Професійне різання бетону, встановлення вікон підвалу та послуги з знесення в Едмонтоні, Альберта.",
      quickLinks: "Швидкі посилання",
      ourServices: "Наші послуги",
      contactUs: "Зв'яжіться з нами",
      service1: "Розширення вікон та дверей",
      service2: "Повне встановлення вікон",
      service3: "Різання підлог та плит",
      service4: "Знесення бетону",
      service5: "Вивезення сміття",
      allRights: "Всі права захищені."
    }
  },
  
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      services: "Services",
      gallery: "Galerie",
      about: "À propos",
      contact: "Obtenir un devis"
    },
    
    // Hero Section
    hero: {
      location: "Desservant Edmonton et ses environs",
      title: "Expert en découpe de béton et agrandissement de fenêtres de sous-sol",
      subtitle: "Vous voulez transformer votre sous-sol sombre en un espace de vie lumineux et légal? Ne risquez pas votre fondation avec des amateurs.",
      description: "Chez South Palmyra Inc, nous fournissons une découpe de béton professionnelle et des installations de fenêtres complètes sans stress pour vous.",
      whyTrust: "Pourquoi les propriétaires nous font confiance:",
      feature1: "Entièrement protégé: couverture WCB et assurance responsabilité civile commerciale",
      feature2: "Conforme au code: chaque fenêtre répond au code du bâtiment de l'Alberta",
      feature3: "Propre et précis: équipement de découpe au diamant spécialisé pour un minimum de poussière",
      feature4: "Local et fiable: fiers de servir Edmonton avec des prix compétitifs",
      ctaPrimary: "Obtenir une estimation gratuite",
      alsoAvailable: "Également disponible:",
      whyTrustCommercial: "Pourquoi les clients commerciaux nous choisissent:",
      commercialFeature1: "Découpe et démolition de béton commercial à grande échelle",
      commercialFeature2: "Licencié, assuré et couvert par la WCB pour votre tranquillité d'esprit",
      commercialFeature3: "Livraison dans les délais pour les projets multi-unités et commerciaux",
      commercialFeature4: "Planification flexible pour minimiser les perturbations commerciales"
    },

    // Commercial
    commercial: {
      badge: "TOUTE TAILLE • TOUTE COMPLEXITÉ",
      capabilitiesTitle: "Capacités Commerciales",
      mainTitle: "TOUTE TAILLE • TOUTE COMPLEXITÉ",
      subtitle: "Approuvé par les entrepreneurs, gestionnaires immobiliers et développeurs à travers l'Alberta",
      projectTypesTitle: "Types de Projets Commerciaux",
      servicesHeader: "Services Commerciaux",
      servicesSubtitle: "Solutions de béton professionnelles pour entrepreneurs, gestionnaires immobiliers et développeurs",
      anySize: {
        title: "Projet de Toute Taille",
        description: "Des coupes individuelles aux démolitions complètes - nous gérons des projets de toute envergure"
      },
      anyComplexity: {
        title: "Toute Complexité",
        description: "Équipement spécialisé et expertise pour les projets de découpe de béton les plus difficiles"
      },
      multiUnit: {
        title: "Multi-Unités et Haute-Rise",
        description: "Expérience avec de grands bâtiments commerciaux, condos et structures à plusieurs étages"
      },
      minimalDisruption: {
        title: "Perturbation Minimale",
        description: "Planification flexible et contrôle de la poussière pour maintenir vos opérations commerciales"
      },
      projectHighRise: "Haute-Rise Commerciale",
      projectDemolition: "Démolition Industrielle",
      projectMultiUnit: "Développement Multi-Unités",
      projectRenovation: "Rénovation Commerciale",
      scaleLarge: "Grande Échelle",
      scaleComplex: "Complexe",
      scaleMultiStory: "Multi-Étages",
      scalePrecision: "Travail de Précision"
    },
    
    // Services
    services: {
      title: "Nos services",
      subtitle: "Solutions de béton professionnelles adaptées aux besoins de votre projet",
      cta: "Demander un devis",
      learnMore: "En savoir plus",
      service1: {
        title: "Agrandissement de fenêtres et portes",
        description: "Agrandissement des ouvertures existantes ou création de nouvelles dans votre fondation pour la lumière naturelle et la sécurité.",
        feature1: "Ouvertures de fenêtres de fondation - création de nouvelles fenêtres de sortie pour des espaces de vie légaux",
        feature2: "Agrandissement d'ouverture existante - agrandissement des fenêtres de sous-sol pour répondre au code du bâtiment de l'Alberta",
        feature3: "Création d'ouverture de porte - nouveaux points d'entrée pour l'accès au sous-sol",
        feature4: "Installations conformes au code - garantir que toutes les ouvertures répondent aux exigences de sécurité",
        feature5: "Équipement de découpe au diamant spécialisé pour une poussière minimale et des bords parfaits"
      },
      service2: {
        title: "Installation complète de fenêtres",
        description: "Solutions clés en main comprenant l'excavation, l'installation de puits de fenêtre, les systèmes de drainage et la pose de fenêtres écoénergétiques.",
        feature1: "Services d'excavation complets - creusage professionnel autour de la fondation",
        feature2: "Installation de puits de fenêtre - enceintes de protection durables pour les fenêtres de sous-sol",
        feature3: "Installation du système de drainage - prévention de l'accumulation d'eau et des inondations du sous-sol",
        feature4: "Pose de fenêtres écoénergétiques - scellement et isolation appropriés",
        feature5: "Imperméabilisation et finition - protection contre l'humidité pour des résultats durables",
        feature6: "Service complet clés en main - du début à la fin sans stress"
      },
      service3: {
        title: "Découpe de planchers et dalles + Démolition",
        description: "Création d'ouvertures pour de nouveaux escaliers et plomberie, plus démolition complète du béton avec enlèvement des débris.",
        feature1: "Découpe de plancher pour escaliers - ouvertures précises pour un nouvel accès au sous-sol",
        feature2: "Ouvertures de plomberie - découpe du béton pour de nouvelles installations de plomberie",
        feature3: "Enlèvement de murs et cloisons - démolition de structures en béton non désirées",
        feature4: "Enlèvement de vieil escalier - démantèlement et élimination d'escaliers en béton",
        feature5: "Enlèvement complet des débris - nettoyage complet et enlèvement des déchets",
        feature6: "Travail propre et précis - perturbation minimale de votre propriété"
      }
    },
    
    // About
    about: {
      title: "À propos de South Palmyra Inc.",
      subtitle: "Votre partenaire de confiance pour des solutions de béton professionnelles à Edmonton, Alberta",
      heading: "Construire l'excellence dans les services de béton",
      paragraph1: "South Palmyra Inc. est un fournisseur de services de découpe de béton et de construction de premier plan basé à Edmonton, Alberta. Nous nous spécialisons dans la fourniture de solutions professionnelles de haute qualité pour les projets résidentiels et commerciaux.",
      paragraph2: "Notre équipe de professionnels expérimentés utilise des équipements de pointe et des techniques éprouvées pour assurer la précision, la sécurité et l'efficacité dans chaque projet que nous entreprenons. De la découpe de béton et des installations de fenêtres de sous-sol à la démolition et à l'enlèvement des déchets, nous gérons tout avec expertise et soin.",
      paragraph3: "Nous sommes fiers de notre engagement envers la satisfaction du client, de notre attention aux détails et de notre capacité à terminer les projets à temps et dans les limites du budget. Lorsque vous choisissez South Palmyra Inc., vous choisissez un partenaire dédié à l'excellence.",
      coreValues: "Nos valeurs fondamentales",
      value1: {
        title: "Excellence",
        description: "Nous maintenons les plus hauts standards de qualité dans chaque projet"
      },
      value2: {
        title: "Précision",
        description: "Attention aux détails et précision dans tous nos travaux de découpe de béton"
      },
      value3: {
        title: "Client d'abord",
        description: "Votre satisfaction est notre priorité, de la consultation à l'achèvement du projet"
      },
      value4: {
        title: "Service professionnel",
        description: "Équipe expérimentée équipée d'outils et techniques de pointe"
      }
    },
    
    // Why Choose Us
    whyChoose: {
      title: "Pourquoi choisir South Palmyra Inc.?",
      description: "Nous sommes les spécialistes de confiance en découpe de béton et construction d'Edmonton, offrant des résultats exceptionnels pour les projets résidentiels et commerciaux dans toute l'Alberta.",
      feature1: {
        title: "Équipe d'experts",
        description: "Professionnels expérimentés avec des années d'expertise en travaux de béton"
      },
      feature2: {
        title: "Service ponctuel",
        description: "Nous respectons votre temps et terminons les projets dans les délais convenus"
      },
      feature3: {
        title: "Qualité garantie",
        description: "Travail de haute qualité avec attention aux détails sur chaque projet"
      },
      feature4: {
        title: "Axé sur le client",
        description: "Dévoués à dépasser les attentes et assurer la satisfaction"
      },
      learnMore: "En savoir plus sur nous"
    },
    
    // Testimonials
    testimonials: {
      title: "Ce que disent nos clients",
      subtitle: "Ne nous croyez pas sur parole - écoutez les clients satisfaits à travers Edmonton"
    },
    
    // Gallery
    gallery: {
      title: "Nos réalisations",
      subtitle: "Explorez notre portfolio de projets terminés à travers Edmonton et l'Alberta"
    },
    
    // Contact
    contact: {
      title: "Obtenez un devis gratuit",
      subtitle: "Parlez-nous de votre projet et nous vous répondrons dans les 24 heures",
      contactInfo: "Coordonnées",
      phonePrimary: "Téléphone (principal)",
      phoneSecondary: "Téléphone (secondaire)",
      email: "Courriel",
      serviceArea: "Zone de service",
      emergency: "Services d'urgence disponibles. Appelez-nous pour une découpe de béton et une démolition urgentes.",
      formTitle: "Demander un devis",
      formName: "Nom complet",
      formPhone: "Numéro de téléphone",
      formEmail: "Adresse courriel",
      formService: "Service requis",
      formAddress: "Adresse du projet",
      formDetails: "Détails du projet",
      formPhotos: "Photos du projet (facultatif)",
      formPhotosDesc: "Téléchargez jusqu'à 5 photos pour nous aider à mieux comprendre votre projet",
      formUpload: "Cliquez pour télécharger des photos",
      formUploadHint: "JPG, PNG jusqu'à 10 Mo chacun",
      formSubmit: "Soumettre la demande",
      formSubmitting: "Envoi en cours...",
      formSuccess: "Nous examinerons votre demande et vous répondrons dans les 24 heures",
      selectService: "Sélectionnez un service"
    },
    
    // Footer
    footer: {
      description: "Découpe de béton professionnelle, installation de fenêtres de sous-sol et services de démolition à Edmonton, Alberta.",
      quickLinks: "Liens rapides",
      ourServices: "Nos services",
      contactUs: "Contactez-nous",
      service1: "Agrandissement de fenêtres et portes",
      service2: "Installation complète de fenêtres",
      service3: "Découpe de planchers et dalles",
      service4: "Démolition de béton",
      service5: "Enlèvement des débris",
      allRights: "Tous droits réservés."
    }
  },
  
  ru: {
    // Navigation
    nav: {
      home: "Главная",
      services: "Услуги",
      gallery: "Галерея",
      about: "О нас",
      contact: "Получить предложение"
    },
    
    // Hero Section
    hero: {
      location: "Обслуживаем Эдмонтон и окрестности",
      title: "Экспертная резка бетона и расширение подвальных окон",
      subtitle: "Хотите превратить темный подвал в светлое, законное жилое пространство? Не рискуйте своим фундаментом с любителями.",
      description: "В South Palmyra Inc мы предоставляем профессиональную резку бетона и полный комплекс услуг по установке окон без стресса для вас.",
      whyTrust: "Почему домовладельцы нам доверяют:",
      feature1: "Полная защита: покрытие WCB и коммерческая страховка ответственности",
      feature2: "Соответствие кодексу: каждое окно соответствует строительному кодексу Альберты",
      feature3: "Чисто и точно: специализированное алмазное оборудование для минимальной пыли",
      feature4: "Местные и надежные: с гордостью обслуживаем Эдмонтон по конкурентным ценам",
      ctaPrimary: "Получить бесплатную оценку",
      alsoAvailable: "Также доступен:",
      whyTrustCommercial: "Почему коммерческие клиенты выбирают нас:",
      commercialFeature1: "Крупномасштабная коммерческая резка и снос бетона",
      commercialFeature2: "Лицензированы, застрахованы и покрыты WCB для вашего спокойствия",
      commercialFeature3: "Доставка по графику для многоквартирных и коммерческих проектов",
      commercialFeature4: "Гибкий график для минимизации нарушений бизнеса"
    },

    // Commercial
    commercial: {
      badge: "ЛЮБОЙ РАЗМЕР • ЛЮБАЯ СЛОЖНОСТЬ",
      capabilitiesTitle: "Коммерческие Возможности",
      mainTitle: "ЛЮБОЙ РАЗМЕР • ЛЮБАЯ СЛОЖНОСТЬ",
      subtitle: "Доверяют подрядчики, управляющие недвижимостью и застройщики по всей Альберте",
      projectTypesTitle: "Типы Коммерческих Проектов",
      servicesHeader: "Коммерческие Услуги",
      servicesSubtitle: "Профессиональные бетонные решения для подрядчиков, управляющих недвижимостью и застройщиков",
      anySize: {
        title: "Проект Любого Размера",
        description: "От одиночных резов до демонтажа целых зданий - мы выполняем проекты любого масштаба"
      },
      anyComplexity: {
        title: "Любая Сложность",
        description: "Специализированное оборудование и опыт для самых сложных проектов резки бетона"
      },
      multiUnit: {
        title: "Многоквартирные и Высотные Здания",
        description: "Опыт резки бетона в крупных коммерческих зданиях, кондоминиумах и многоэтажных сооружениях"
      },
      minimalDisruption: {
        title: "Минимальные Нарушения",
        description: "Гибкий график и контроль пыли для бесперебойной работы вашего бизнеса"
      },
      projectHighRise: "Высотные Здания",
      projectDemolition: "Промышленный Демонтаж",
      projectMultiUnit: "Многоквартирные Дома",
      projectRenovation: "Коммерческий Ремонт",
      scaleLarge: "Большой Масштаб",
      scaleComplex: "Сложный",
      scaleMultiStory: "Многоэтажный",
      scalePrecision: "Точная Работа"
    },
    
    // Services
    services: {
      title: "Наши услуги",
      subtitle: "Профессиональные бетонные решения, адаптированные к потребностям вашего проекта",
      cta: "Запросить предложение",
      learnMore: "Узнать больше",
      service1: {
        title: "Расширение окон и дверей",
        description: "Расширение существующих проемов или создание новых в вашем фундаменте для естественного освещения и безопасности.",
        feature1: "Оконные проемы в фундаменте - создание новых аварийных окон для легальных жилых помещений",
        feature2: "Расширение существующих проемов - увеличение подвальных окон в соответствии со строительным кодексом Альберты",
        feature3: "Создание дверных проемов - новые точки входа для доступа в подвал",
        feature4: "Установки, соответствующие кодексу - обеспечение соответствия всех проемов требованиям безопасности",
        feature5: "Специализированное алмазное оборудование для минимальной пыли и идеальных краев"
      },
      service2: {
        title: "Полная установка окон",
        description: "Комплексные решения, включая земляные работы, установку оконных колодцев, дренажные системы и энергоэффективную установку окон.",
        feature1: "Полные услуги по земляным работам - профессиональная копка вокруг фундамента",
        feature2: "Установка оконного колодца - прочные защитные корпуса для подвальных окон",
        feature3: "Настройка дренажной системы - предотвращение скопления воды и затопления подвала",
        feature4: "Энергоэффективная установка окон - надлежащая герметизация и изоляция",
        feature5: "Гидроизоляция и отделка - защита от влаги для долговечных результатов",
        feature6: "Полный сервис под ключ - от начала до конца без стресса"
      },
      service3: {
        title: "Резка полов и плит + Демонтаж",
        description: "Создание проемов для новых лестниц и сантехники, а также полный демонтаж бетона с вывозом мусора.",
        feature1: "Резка пола для лестниц - точные проемы для нового доступа в подвал",
        feature2: "Проемы для сантехники - резка бетона для новых сантехнических установок",
        feature3: "Удаление стен и перегородок - снос нежелательных бетонных конструкций",
        feature4: "Удаление старых лестниц - демонтаж и утилизация бетонных лестниц",
        feature5: "Полный вывоз мусора - полная уборка и удаление отходов",
        feature6: "Чистая и точная работа - минимальные нарушения вашей собственности"
      }
    },
    
    // About
    about: {
      title: "О South Palmyra Inc.",
      subtitle: "Ваш надежный партнер для профессиональных бетонных решений в Эдмонтоне, Альберта",
      heading: "Создаем совершенство в бетонных услугах",
      paragraph1: "South Palmyra Inc. является ведущим поставщиком услуг по резке бетона и строительству в Эдмонтоне, Альберта. Мы специализируемся на предоставлении высококачественных профессиональных решений как для жилых, так и для коммерческих проектов.",
      paragraph2: "Наша команда опытных профессионалов использует самое современное оборудование и проверенные методы для обеспечения точности, безопасности и эффективности в каждом проекте. От резки бетона и установки подвальных окон до демонтажа и вывоза отходов - мы делаем все с профессионализмом.",
      paragraph3: "Мы гордимся нашей приверженностью удовлетворенности клиентов, вниманием к деталям и способностью завершать проекты вовремя и в рамках бюджета. Выбирая South Palmyra Inc., вы выбираете партнера, преданного совершенству.",
      coreValues: "Наши основные ценности",
      value1: {
        title: "Совершенство",
        description: "Мы поддерживаем самые высокие стандарты качества в каждом проекте"
      },
      value2: {
        title: "Точность",
        description: "Внимание к деталям и точность во всех наших работах по резке бетона"
      },
      value3: {
        title: "Клиент на первом месте",
        description: "Ваше удовлетворение - наш приоритет, от консультации до завершения проекта"
      },
      value4: {
        title: "Профессиональный сервис",
        description: "Опытная команда с современным оборудованием и технологиями"
      }
    },
    
    // Why Choose Us
    whyChoose: {
      title: "Почему выбирают South Palmyra Inc.?",
      description: "Мы являемся надежными специалистами по резке бетона и строительству в Эдмонтоне, обеспечивающими исключительные результаты для жилых и коммерческих проектов по всей Альберте.",
      feature1: {
        title: "Экспертная команда",
        description: "Опытные профессионалы с многолетним опытом работы с бетоном"
      },
      feature2: {
        title: "Своевременный сервис",
        description: "Мы уважаем ваше время и завершаем проекты в согласованные сроки"
      },
      feature3: {
        title: "Гарантированное качество",
        description: "Высококачественная работа с вниманием к деталям в каждом проекте"
      },
      feature4: {
        title: "Ориентация на клиента",
        description: "Стремимся превзойти ожидания и обеспечить удовлетворенность"
      },
      learnMore: "Узнать больше о нас"
    },
    
    // Testimonials
    testimonials: {
      title: "Что говорят наши клиенты",
      subtitle: "Не верьте нам на слово - послушайте довольных клиентов по всему Эдмонтону"
    },
    
    // Gallery
    gallery: {
      title: "Наши работы",
      subtitle: "Ознакомьтесь с нашим портфолио завершенных проектов по Эдмонтону и Альберте"
    },
    
    // Contact
    contact: {
      title: "Получите бесплатное предложение",
      subtitle: "Расскажите нам о своем проекте, и мы свяжемся с вами в течение 24 часов",
      contactInfo: "Контактная информация",
      phonePrimary: "Телефон (основной)",
      phoneSecondary: "Телефон (дополнительный)",
      email: "Электронная почта",
      serviceArea: "Зона обслуживания",
      emergency: "Доступны экстренные услуги. Звоните нам для срочной резки бетона и демонтажа.",
      formTitle: "Запрос предложения",
      formName: "Полное имя",
      formPhone: "Номер телефона",
      formEmail: "Адрес электронной почты",
      formService: "Необходимая услуга",
      formAddress: "Адрес проекта",
      formDetails: "Детали проекта",
      formPhotos: "Фотографии проекта (необязательно)",
      formPhotosDesc: "Загрузите до 5 фотографий, чтобы помочь нам лучше понять ваш проект",
      formUpload: "Нажмите, чтобы загрузить фотографии",
      formUploadHint: "JPG, PNG до 10 МБ каждый",
      formSubmit: "Отправить запрос",
      formSubmitting: "Отправка...",
      formSuccess: "Мы рассмотрим ваш запрос и свяжемся с вами в течение 24 часов",
      selectService: "Выберите услугу"
    },
    
    // Footer
    footer: {
      description: "Профессиональная резка бетона, установка подвальных окон и услуги демонтажа в Эдмонтоне, Альберта.",
      quickLinks: "Быстрые ссылки",
      ourServices: "Наши услуги",
      contactUs: "Свяжитесь с нами",
      service1: "Расширение окон и дверей",
      service2: "Полная установка окон",
      service3: "Резка полов и плит",
      service4: "Демонтаж бетона",
      service5: "Вывоз мусора",
      allRights: "Все права защищены."
    }
  },
  
  zh: {
    // Navigation
    nav: {
      home: "首页",
      services: "服务",
      gallery: "画廊",
      about: "关于",
      contact: "获取报价"
    },
    
    // Hero Section
    hero: {
      location: "服务埃德蒙顿及周边地区",
      title: "专业混凝土切割和地下室窗户扩建",
      subtitle: "想把黑暗的地下室变成明亮、合法的生活空间？不要让业余人员冒险处理您的基础。",
      description: "在South Palmyra Inc，我们提供专业的混凝土切割和全方位的窗户安装服务，让您零压力。",
      whyTrust: "为什么房主信任我们：",
      feature1: "全面保护：WCB保险和商业综合责任保险",
      feature2: "符合规范：每个逃生窗都符合阿尔伯塔省建筑规范",
      feature3: "清洁精确：专业金刚石切割设备，灰尘最少",
      feature4: "本地可靠：自豪地以有竞争力的价格服务埃德蒙顿",
      ctaPrimary: "获取免费评估",
      alsoAvailable: "也可用:",
      whyTrustCommercial: "为什么商业客户选择我们:",
      commercialFeature1: "大规模商业混凝土切割和拆除",
      commercialFeature2: "获得许可、投保和WCB覆盖，让您安心",
      commercialFeature3: "多单元和商业项目按时交付",
      commercialFeature4: "灵活的时间安排，最大限度减少业务中断"
    },

    // Commercial
    commercial: {
      badge: "任何规模 • 任何复杂度",
      capabilitiesTitle: "商业能力",
      mainTitle: "任何规模 • 任何复杂度",
      subtitle: "受阿尔伯塔省承包商、物业管理人员和开发商信赖",
      projectTypesTitle: "商业项目类型",
      servicesHeader: "商业服务",
      servicesSubtitle: "为承包商、物业管理人员和开发商提供专业混凝土解决方案",
      anySize: {
        title: "任何规模项目",
        description: "从单次切割到整栋建筑拆除 - 我们处理任何规模的项目"
      },
      anyComplexity: {
        title: "任何复杂度",
        description: "专业设备和专业知识处理最具挑战性的混凝土切割项目"
      },
      multiUnit: {
        title: "多单元和高层",
        description: "大型商业建筑、公寓和多层结构的经验"
      },
      minimalDisruption: {
        title: "最小干扰",
        description: "灵活的时间安排和粉尘控制，确保您的业务顺利运行"
      },
      projectHighRise: "商业高层",
      projectDemolition: "工业拆除",
      projectMultiUnit: "多单元开发",
      projectRenovation: "商业装修",
      scaleLarge: "大规模",
      scaleComplex: "复杂",
      scaleMultiStory: "多层",
      scalePrecision: "精密工作"
    },
    
    // Services
    services: {
      title: "我们的服务",
      subtitle: "为您的项目需求量身定制的专业混凝土解决方案",
      cta: "申请报价",
      learnMore: "了解更多",
      service1: {
        title: "窗户和门扩建",
        description: "扩大现有开口或在您的基础中切割新开口，以获得自然光和安全性。",
        feature1: "基础窗户开口 - 为合法居住空间创建新的逃生窗",
        feature2: "现有开口扩建 - 扩大地下室窗户以符合阿尔伯塔省建筑规范",
        feature3: "门开口创建 - 为地下室通道创建新的入口点",
        feature4: "符合规范的安装 - 确保所有开口符合安全要求",
        feature5: "专业金刚石切割设备，灰尘最少，边缘完美"
      },
      service2: {
        title: "完整的窗户安装",
        description: "一站式解决方案，包括挖掘、窗井安装、排水系统和节能窗户安装。",
        feature1: "完整的挖掘服务 - 围绕基础进行专业挖掘",
        feature2: "窗井安装 - 为地下室窗户提供耐用的保护罩",
        feature3: "排水系统设置 - 防止积水和地下室洪水",
        feature4: "节能窗户安装 - 适当的密封和隔热",
        feature5: "防水和装饰 - 防潮保护以获得持久效果",
        feature6: "全面的一站式服务 - 从开始到结束零压力"
      },
      service3: {
        title: "地板和板材切割 + 拆除",
        description: "为新楼梯和管道创建开口，以及完整的混凝土拆除和碎片清运。",
        feature1: "楼梯地板切割 - 为新地下室通道精确开口",
        feature2: "管道开口 - 为新管道安装切割混凝土",
        feature3: "墙壁和隔断拆除 - 拆除不需要的混凝土结构",
        feature4: "旧楼梯拆除 - 拆卸和处理混凝土楼梯",
        feature5: "完整的碎片清运 - 完整清理和废物清除",
        feature6: "干净精确的工作 - 对您的财产造成最小干扰"
      }
    },
    
    // About
    about: {
      title: "关于South Palmyra Inc.",
      subtitle: "您在埃德蒙顿、阿尔伯塔省专业混凝土解决方案的可靠合作伙伴",
      heading: "在混凝土服务中建立卓越",
      paragraph1: "South Palmyra Inc.是位于阿尔伯塔省埃德蒙顿的领先混凝土切割和建筑服务提供商。我们专门为住宅和商业项目提供高质量的专业解决方案。",
      paragraph2: "我们经验丰富的专业团队使用最先进的设备和经过验证的技术，确保我们承接的每个项目的精确性、安全性和效率。从混凝土切割和地下室窗户安装到拆除和废物清除，我们以专业知识和关怀处理所有事务。",
      paragraph3: "我们以对客户满意度的承诺、对细节的关注以及按时按预算完成项目的能力而自豪。当您选择South Palmyra Inc.时，您选择了致力于卓越的合作伙伴。",
      coreValues: "我们的核心价值观",
      value1: {
        title: "卓越",
        description: "我们在每个项目中保持最高的质量标准"
      },
      value2: {
        title: "精确",
        description: "在所有混凝土切割和建筑工作中注重细节和准确性"
      },
      value3: {
        title: "客户至上",
        description: "从咨询到项目完成，您的满意是我们的优先事项"
      },
      value4: {
        title: "专业服务",
        description: "配备最先进工具和技术的经验丰富的团队"
      }
    },
    
    // Testimonials
    testimonials: {
      title: "客户评价",
      subtitle: "不要只听我们的话 - 听听埃德蒙顿满意客户的声音"
    },
    
    // Gallery
    gallery: {
      title: "我们的工作",
      subtitle: "探索我们在埃德蒙顿和阿尔伯塔省完成的项目组合"
    },
    
    // Contact
    contact: {
      title: "获取免费报价",
      subtitle: "告诉我们您的项目，我们将在24小时内与您联系",
      contactInfo: "联系信息",
      phonePrimary: "电话（主要）",
      phoneSecondary: "电话（次要）",
      email: "电子邮件",
      serviceArea: "服务区域",
      emergency: "提供紧急服务。如需紧急混凝土切割和拆除，请致电我们。",
      formTitle: "申请报价",
      formName: "全名",
      formPhone: "电话号码",
      formEmail: "电子邮件地址",
      formService: "所需服务",
      formAddress: "项目地址",
      formDetails: "项目详情",
      formPhotos: "项目照片（可选）",
      formPhotosDesc: "上传最多5张照片以帮助我们更好地了解您的项目",
      formUpload: "点击上传照片",
      formUploadHint: "JPG、PNG，每个最大10MB",
      formSubmit: "提交报价请求",
      formSubmitting: "提交中...",
      formSuccess: "我们将审核您的请求并在24小时内与您联系",
      selectService: "选择服务"
    },
    
    // Footer
    footer: {
      description: "埃德蒙顿、阿尔伯塔省的专业混凝土切割、地下室窗户安装和拆除服务。",
      quickLinks: "快速链接",
      ourServices: "我们的服务",
      contactUs: "联系我们",
      service1: "窗户和门扩建",
      service2: "完整的窗户安装",
      service3: "地板和板材切割",
      service4: "混凝土拆除",
      service5: "碎片清运",
      allRights: "版权所有。"
    }
  },
  
  tl: {
    // Navigation
    nav: {
      home: "Home",
      services: "Mga Serbisyo",
      gallery: "Gallery",
      about: "Tungkol",
      contact: "Kumuha ng Presyo"
    },
    
    // Hero Section
    hero: {
      location: "Naglilingkod sa Edmonton at Karatig Lugar",
      title: "Eksperto sa Pagputol ng Konkreto at Pagpapalaki ng Bintana sa Basement",
      subtitle: "Gusto mong gawing maliwanag at legal na tirahan ang iyong madilim na basement? Huwag ipanganib ang iyong pundasyon sa mga amateur.",
      description: "Sa South Palmyra Inc, nagbibigay kami ng propesyonal na pagputol ng konkreto at kumpletong serbisyo sa pag-install ng bintana nang walang stress para sa iyo.",
      whyTrust: "Bakit nagtitiwala sa amin ang mga may-ari ng bahay:",
      feature1: "Ganap na Protektado: WCB coverage at Commercial General Liability insurance",
      feature2: "Sumusunod sa Code: Bawat escape window ay sumusunod sa Alberta Building Code",
      feature3: "Malinis at Tumpak: Specialized diamond cutting equipment para sa minimal na alikabok",
      feature4: "Lokal at Mapagkakatiwalaan: Proud na naglilingkod sa Edmonton sa competitive pricing",
      ctaPrimary: "Kumuha ng Libreng Estimate",
      alsoAvailable: "Available din:",
      whyTrustCommercial: "Bakit pumipili sa amin ang mga komersyal na kliyente:",
      commercialFeature1: "Malakihang komersyal na pagputol at demolisyon ng konkreto",
      commercialFeature2: "Lisensyado, naka-insure at saklaw ng WCB para sa kapayapaan ng isip",
      commercialFeature3: "Nag-deliver sa iskedyul para sa multi-unit at komersyal na proyekto",
      commercialFeature4: "Flexible na pag-iskedyul upang mabawasan ang sagabal sa negosyo"
    },

    // Commercial
    commercial: {
      badge: "ANUMANG LAKI • ANUMANG KOMPLIKASYON",
      capabilitiesTitle: "Mga Kakayahan sa Komersyal",
      mainTitle: "ANUMANG LAKI • ANUMANG KOMPLIKASYON",
      subtitle: "Pinagkakatiwalaan ng mga contractor, property manager, at developer sa buong Alberta",
      projectTypesTitle: "Mga Uri ng Komersyal na Proyekto",
      servicesHeader: "Mga Serbisyong Komersyal",
      servicesSubtitle: "Propesyonal na solusyon sa konkreto para sa mga contractor, property manager, at developer",
      anySize: {
        title: "Anumang Laki ng Proyekto",
        description: "Mula sa mga solong pagputol hanggang sa kumpletong demolisyon ng gusali - hinahawakan namin ang mga proyekto ng anumang sukat"
      },
      anyComplexity: {
        title: "Anumang Komplikasyon",
        description: "Espesyalisadong kagamitan at kadalubhasaan para sa pinakamahirap na mga proyekto ng pagputol ng konkreto"
      },
      multiUnit: {
        title: "Multi-Unit at Mataas na Gusali",
        description: "Karanasan sa malalaking komersyal na gusali, condo, at multi-story na istruktura"
      },
      minimalDisruption: {
        title: "Minimal na Sagabal",
        description: "Flexible na pag-iskedyul at kontrol sa alikabok upang mapanatili ang iyong operasyon ng negosyo"
      },
      projectHighRise: "Komersyal na Mataas na Gusali",
      projectDemolition: "Industriyal na Demolisyon",
      projectMultiUnit: "Multi-Unit na Pag-unlad",
      projectRenovation: "Komersyal na Renovation",
      scaleLarge: "Malaking Sukat",
      scaleComplex: "Komplikado",
      scaleMultiStory: "Multi-Palapag",
      scalePrecision: "Tumpak na Trabaho"
    },
    
    // Services
    services: {
      title: "Aming Mga Serbisyo",
      subtitle: "Propesyonal na solusyon sa konkreto na iniaangkop sa pangangailangan ng iyong proyekto",
      cta: "Humiling ng Presyo",
      learnMore: "Matuto Pa",
      service1: {
        title: "Pagpapalaki ng Bintana at Pinto",
        description: "Pagpapalaki ng umiiral na butas o pagputol ng mga bago sa iyong pundasyon para sa natural na liwanag at kaligtasan.",
        feature1: "Mga butas ng bintana sa pundasyon - paggawa ng mga bagong escape window para sa legal na tirahan",
        feature2: "Pagpapalaki ng umiiral na butas - pagpapalaki ng mga bintana sa basement upang matugunan ang Alberta Building Code",
        feature3: "Paggawa ng butas ng pinto - mga bagong entry point para sa access sa basement",
        feature4: "Mga pag-install na sumusunod sa code - pagtitiyak na lahat ng butas ay nakakatugon sa mga kinakailangan sa kaligtasan",
        feature5: "Specialized diamond cutting equipment para sa minimal na alikabok at perpektong gilid"
      },
      service2: {
        title: "Kumpletong Pag-install ng Bintana",
        description: "Turn-key na solusyon kasama ang paghuhukay, pag-setup ng window well, drainage system, at energy-efficient window fitting.",
        feature1: "Kumpletong serbisyo sa paghuhukay - propesyonal na paghuhukay sa paligid ng pundasyon",
        feature2: "Pag-install ng window well - matibay na protective enclosure para sa basement windows",
        feature3: "Pag-setup ng drainage system - pag-iwas sa pag-ipon ng tubig at pagbaha sa basement",
        feature4: "Energy-efficient window fitting - wastong sealing at insulation",
        feature5: "Waterproofing at finishing - proteksyon sa halumigmig para sa pangmatagalang resulta",
        feature6: "Kumpletong turn-key service - mula simula hanggang dulo na walang stress"
      },
      service3: {
        title: "Pagputol ng Sahig at Slab + Pagwasak",
        description: "Paggawa ng butas para sa mga bagong hagdan at tubo, plus kumpletong pagwasak ng konkreto at pag-alis ng basura.",
        feature1: "Pagputol ng sahig para sa hagdan - tumpak na butas para sa bagong access sa basement",
        feature2: "Mga butas ng tubo - pagputol ng konkreto para sa mga bagong plumbing installation",
        feature3: "Pag-alis ng pader at partition - pagwasak ng hindi gustong mga istruktura ng konkreto",
        feature4: "Pag-alis ng lumang hagdan - pag-dismantle at pagtatapon ng mga hagdan na konkreto",
        feature5: "Kumpletong pag-alis ng basura - kumpletong paglilinis at pag-alis ng basura",
        feature6: "Malinis at tumpak na trabaho - minimal na pagkagambala sa iyong ari-arian"
      }
    },
    
    // About
    about: {
      title: "Tungkol sa South Palmyra Inc.",
      subtitle: "Ang iyong mapagkakatiwalaang kasosyo para sa propesyonal na solusyon sa konkreto sa Edmonton, Alberta",
      heading: "Pagbuo ng Kahusayan sa Mga Serbisyo sa Konkreto",
      paragraph1: "Ang South Palmyra Inc. ay isang nangungunang provider ng serbisyo sa pagputol ng konkreto at konstruksiyon na nakabase sa Edmonton, Alberta. Kami ay dalubhasa sa paghahatid ng mataas na kalidad, propesyonal na solusyon para sa residential at commercial na proyekto.",
      paragraph2: "Ang aming koponan ng mga propesyonal na may karanasan ay gumagamit ng state-of-the-art na kagamitan at napatunayang mga pamamaraan upang matiyak ang katumpakan, kaligtasan, at kahusayan sa bawat proyektong ginagawa namin. Mula sa pagputol ng konkreto at pag-install ng bintana sa basement hanggang sa pagwasak at pag-alis ng basura, hinahawakan namin ang lahat ng may kadalubhasaan at pag-aalaga.",
      paragraph3: "Ipinagmamalaki namin ang aming pangako sa kasiyahan ng customer, pansin sa detalye, at kakayahang kumpletuhin ang mga proyekto sa tamang oras at sa loob ng badyet. Kapag pumili ka ng South Palmyra Inc., pumipili ka ng kasosyo na dedikado sa kahusayan.",
      coreValues: "Aming Mga Pangunahing Halaga",
      value1: {
        title: "Kahusayan",
        description: "Pinapanatili namin ang pinakamataas na pamantayan ng kalidad sa bawat proyektong ginagawa namin"
      },
      value2: {
        title: "Katumpakan",
        description: "Atensyon sa detalye at katumpakan sa lahat ng aming trabaho sa pagputol ng konkreto"
      },
      value3: {
        title: "Customer Muna",
        description: "Ang iyong kasiyahan ay aming priyoridad, mula sa konsultasyon hanggang sa pagkumpleto ng proyekto"
      },
      value4: {
        title: "Propesyonal na Serbisyo",
        description: "Koponan na may karanasan na may state-of-the-art na tools at techniques"
      }
    },
    
    // Why Choose Us
    whyChoose: {
      title: "Bakit Piliin ang South Palmyra Inc.?",
      description: "Kami ang pinagkakatiwalaang espesyalista sa pagputol ng konkreto at konstruksiyon sa Edmonton, na naghahatid ng kahusayan para sa residential at commercial na proyekto sa buong Alberta.",
      feature1: {
        title: "Eksperto ang Koponan",
        description: "Mga propesyonal na may taong-taong karanasan sa trabaho sa konkreto"
      },
      feature2: {
        title: "On-Time na Serbisyo",
        description: "Respeto namin ang iyong oras at kumpleto ang mga proyekto sa napagkasunduang timeline"
      },
      feature3: {
        title: "Garantisadong Kalidad",
        description: "Mataas na kalidad ng gawa na may pansin sa detalye sa bawat proyekto"
      },
      feature4: {
        title: "Nakatuon sa Customer",
        description: "Dedikado sa paglampas sa inaasahan at pagtiyak ng kasiyahan"
      },
      learnMore: "Matuto Pa Tungkol sa Amin"
    },
    
    // Testimonials
    testimonials: {
      title: "Ano ang Sinasabi ng Aming Mga Kliyente",
      subtitle: "Huwag lang magtiwala sa amin - makinig sa mga satisfied na customer sa buong Edmonton"
    },
    
    // Gallery
    gallery: {
      title: "Aming Mga Trabaho",
      subtitle: "Tuklasin ang aming portfolio ng nakumpletong proyekto sa Edmonton at Alberta"
    },
    
    // Contact
    contact: {
      title: "Kumuha ng Libreng Presyo",
      subtitle: "Sabihin sa amin ang tungkol sa iyong proyekto at babalikan ka namin sa loob ng 24 oras",
      contactInfo: "Impormasyon sa Pakikipag-ugnayan",
      phonePrimary: "Telepono (Pangunahin)",
      phoneSecondary: "Telepono (Pangalawa)",
      email: "Email",
      serviceArea: "Lugar ng Serbisyo",
      emergency: "May emergency services. Tumawag sa amin para sa agarang pagputol ng konkreto at pagwasak.",
      formTitle: "Humiling ng Presyo",
      formName: "Buong Pangalan",
      formPhone: "Numero ng Telepono",
      formEmail: "Email Address",
      formService: "Kailangang Serbisyo",
      formAddress: "Address ng Proyekto",
      formDetails: "Mga Detalye ng Proyekto",
      formPhotos: "Mga Larawan ng Proyekto (Opsyonal)",
      formPhotosDesc: "Mag-upload ng hanggang 5 larawan upang matulungan kaming maunawaan nang mas mabuti ang iyong proyekto",
      formUpload: "Mag-click upang mag-upload ng mga larawan",
      formUploadHint: "JPG, PNG hanggang 10MB bawat isa",
      formSubmit: "Isumite ang Kahilingan",
      formSubmitting: "Isinusumite...",
      formSuccess: "Susuriin namin ang iyong kahilingan at babalikan ka namin sa loob ng 24 oras",
      selectService: "Pumili ng serbisyo"
    },
    
    // Footer
    footer: {
      description: "Propesyonal na pagputol ng konkreto, pag-install ng bintana sa basement, at mga serbisyo sa pagwasak sa Edmonton, Alberta.",
      quickLinks: "Mabilis na Mga Link",
      ourServices: "Aming Mga Serbisyo",
      contactUs: "Makipag-ugnayan sa Amin",
      service1: "Pagpapalaki ng Bintana at Pinto",
      service2: "Kumpletong Pag-install ng Bintana",
      service3: "Pagputol ng Sahig at Slab",
      service4: "Pagwasak ng Konkreto",
      service5: "Pag-alis ng Basura",
      allRights: "Lahat ng karapatan ay nakalaan."
    }
  }
};
